export function initNewsLoadMore() {
	document.querySelectorAll("[data-news]").forEach((section) => {
		const list = section.querySelector("[data-news-list]");
		const footer = section.querySelector(".c-newsall_after");
		const button = footer?.querySelector("button");
		const status = section.querySelector("[data-news-status]");

		if (!list || !footer || !button || !status) return;

		let loading = false;
		let offset = Number(section.dataset.newsOffset) || 0;
		const originalLabel = button.textContent;

		button.addEventListener("click", async () => {
			if (loading) return;

			loading = true;
			button.disabled = true;
			button.textContent = "Chargement…";
			list.setAttribute("aria-busy", "true");
			status.textContent = "";

			const body = new URLSearchParams({
				action: "matexpert_load_news",
				nonce: section.dataset.newsNonce,
				offset: String(offset),
			});

			try {
				const response = await fetch(section.dataset.newsUrl, {
					method: "POST",
					credentials: "same-origin",
					body,
				});

				const result = await response.json();

				if (!response.ok || !result.success) {
					throw new Error(result.data?.message || "Impossible de charger les nouvelles.");
				}

				list.insertAdjacentHTML("beforeend", result.data.html);
				offset = result.data.offset;
				section.dataset.newsOffset = String(offset);

				// Retire le bouton après l’ajout des derniers résultats.
				if (!result.data.has_more) {
					footer.hidden = true;
				}
			} catch (error) {
				status.textContent = error.message || "Une erreur est survenue. Veuillez réessayer.";
			} finally {
				loading = false;
				button.disabled = false;
				button.textContent = originalLabel;
				list.removeAttribute("aria-busy");
			}
		});
	});
}
